import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const FormValues = ({ setFormValue }: { setFormValue: (value: unknown) => void }) => {
  const { values } = useFormikContext();
  useEffect(() => {
    setFormValue(values);
  }, [values, setFormValue]);
  return <></>;
};

export default FormValues;
